import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ApiCustom from "../../utils/ApiCustom";
import { Link } from "react-router-dom";
import { HomeIcon } from "@heroicons/react/24/outline";

const MemberDetailView = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    getData();
  }, [slug]);

  const getData = () => {
    ApiCustom.get("/user-show-by-name/" + slug)
      .then((res) => {
        if (res.data.data?.data) {
          setData(res.data.data?.data);
        }
      })
      .catch((err) => console.log(err));
  };

  const renderProfile = () => {
    if (!data) {
      return (
        <div className="alert alert-info shadow-lg max-w-4xl mx-auto mt-8">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="stroke-current flex-shrink-0 h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <span>Không tìm thấy thông tin hội viên</span>
          </div>
        </div>
      );
    }

    if (!data?.userProfile || data?.userProfile == "") {
      return (
        <div className="alert alert-info shadow-lg max-w-4xl mx-auto mt-8">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="stroke-current flex-shrink-0 h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            <span>Chưa tải lên hình hồ sơ</span>
          </div>
        </div>
      );
    }

    return (
      <div className="relative w-full max-w-2xl mx-auto">
        <img
          src={data?.userProfile}
          alt="Background"
          className="w-full h-auto object-cover"
        />
      </div>
    );
  };

  return (
    <div className="container mx-auto">
      <nav className="flex text-gray-500 text-sm mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2">
          <li className="inline-flex items-center">
            <Link
              to="/"
              className="inline-flex items-center hover:text-blue-600 font-medium"
            >
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg
                className="w-3 h-3 mx-2 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <span className="ml-1 text-gray-400 font-medium">
                Ban chấp hành
              </span>
            </div>
          </li>
        </ol>
      </nav>

      {renderProfile()}
    </div>
  );
};

export default MemberDetailView;
